import React from 'react';
import { CheckboxContainer, CheckboxLabel, ErrorText } from './Styles';

interface CheckboxProps {
  id: string;
  name: string;
  label: string;
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  error?: string;
}

const Checkbox: React.FC<CheckboxProps> = ({
  id,
  name,
  label,
  checked,
  onChange,
  required = false,
  error,
}) => {
  return (
    <>
      <CheckboxContainer>
        <input
          id={id}
          name={name}
          type="checkbox"
          checked={checked}
          onChange={onChange}
          required={required}
          aria-required={required}
          aria-invalid={!!error}
          aria-describedby={error ? `${id}-error` : undefined}
        />
        <CheckboxLabel htmlFor={id}>
          {label} {required && '*'}
        </CheckboxLabel>
      </CheckboxContainer>
    </>
  );
};

export default Checkbox;
